"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateMenuItemMutationOptions = exports.updateMenuItemMutation = void 0;
const client_1 = require("@apollo/client");
const menuPlanner_1 = require("../queries/menuPlanner");
exports.updateMenuItemMutation = client_1.gql `
  mutation UpdateMenuItem($menuItem: MenuItemUpdateInput!) {
    updateMenuItem(menuItem: $menuItem) {
      ok
    }
  }
`;
exports.updateMenuItemMutationOptions = (variables, menuPlannerQueryVariables, toVariables) => ({
    variables,
    optimisticResponse: {
        __typename: "Mutation",
        updateMenuItem: {
            __typename: "OkResponse",
            ok: true,
        },
    },
    update: (store, { data: dataResponse }) => {
        if (!dataResponse || !menuPlannerQueryVariables) {
            return;
        }
        const data = store.readQuery({
            query: menuPlanner_1.menuPlannerQuery,
            variables: menuPlannerQueryVariables,
        });
        let menuItemThatMoved = toVariables &&
            data &&
            data.menuPlanner.find(x => x.id === variables.menuItem.id);
        if (data) {
            store.writeQuery({
                query: menuPlanner_1.menuPlannerQuery,
                variables: menuPlannerQueryVariables,
                data: Object.assign(Object.assign({}, data), { menuPlanner: toVariables
                        ? data.menuPlanner.filter(x => x.id !== variables.menuItem.id)
                        : data.menuPlanner.map(mi => {
                            var _a;
                            return mi.id === variables.menuItem.id
                                ? Object.assign(Object.assign(Object.assign({}, mi), variables.menuItem), { scale: (_a = variables.menuItem.scale) !== null && _a !== void 0 ? _a : ("scale" in mi ? mi.scale : 1) }) : mi;
                        }) }),
            });
        }
        if (toVariables) {
            let data2;
            try {
                data2 = store.readQuery({
                    query: menuPlanner_1.menuPlannerQuery,
                    variables: toVariables,
                });
            }
            catch (_a) { }
            if (data2 && menuItemThatMoved) {
                store.writeQuery({
                    query: menuPlanner_1.menuPlannerQuery,
                    variables: toVariables,
                    data: Object.assign(Object.assign({ __typename: "Query" }, data), { menuPlanner: [
                            ...data2.menuPlanner,
                            Object.assign(Object.assign(Object.assign({}, menuItemThatMoved), variables.menuItem), { scale: menuItemThatMoved.scale }),
                        ] }),
                });
            }
        }
    },
});
//# sourceMappingURL=updateMenuItem.js.map